module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei7.svg";